module.exports = __webpack_public_path__ + "static/media/respondant_basic.5f2e1bd4.pdf";